<template>
  <div class="add-box common-shadow">
    <vxe-table
        border="none"
        show-overflow
        class="table-style"
        :auto-resize="true"
        align="center"
        :data="tableData"
    >
      <vxe-table-column field="ordersNum" title="订单编号"
                        :width="isHavePermission('ordersTwo:relOrdersNum') ? '10%' : '12.5%'">
      </vxe-table-column>
      <vxe-table-column
          field="relOrdersNum"
          title="关联订单"
          v-if="isHavePermission('ordersTwo:relOrdersNum')"
          width="10%"
      >
        <template v-slot="{ row }">
          <a @click="openOrderDetail(row.relOrdersId)">{{ row.relOrdersNum }}</a>
        </template>
      </vxe-table-column>
      <vxe-table-column field="busType" title="业务类型"
                        :width="isHavePermission('ordersTwo:relOrdersNum') ? '10%' : '10%'">
        <template v-slot="{ row }">
          <span>{{ row.busTypeText }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="ordersTitle"
          v-if="isHavePermission('ordersTwo:showTitle')"
          title="订单标题"
          :width="isHavePermission('ordersTwo:relOrdersNum') ? '15%' : '12.5%'"
      ></vxe-table-column>
      <vxe-table-column
          field="compName"
          title="平台企业"
          :width="isHavePermission('ordersTwo:relOrdersNum') ? '15%' : '17.5%'"
      ></vxe-table-column>
      <vxe-table-column
          v-if="isHavePermission('ordersTwo:saleMan')"
          field="saleMan"
          title="业务员"
          :width="isHavePermission('ordersTwo:relOrdersNum') ? '10%' : '10%'"
      ></vxe-table-column>
      <vxe-table-column
          v-if="isHavePermission('ordersTwo:manager')"
          field="clientManager"
          title="客户经理"
          :width="isHavePermission('ordersTwo:relOrdersNum') ? '10%' : '12.5%'"
      ></vxe-table-column>
      <vxe-table-column
          v-if="isHavePermission('ordersTwo:manager')"
          field="saleManager"
          title="销售经理"
          :width="isHavePermission('ordersTwo:relOrdersNum') ? '10%' : '12.5%'"
      ></vxe-table-column>
      <vxe-table-column field="ordersState" title="订单状态"
                        :width="isHavePermission('ordersTwo:relOrdersNum') ? '10%' : '12.5%'">
        <template v-slot="{ row }">
          <span>{{ row.ordersState | ordersStateMap }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  mixins: [getAuthOrization],
  props: {
    detailData: Object
  },
  watch: {
    detailData(val) {
      if (val) {
        this.tableData = [
          {
            busTypeText: val.busTypeText,
            ordersNum: val.ordersNum,
            busType: val.busType,
            ordersTitle: val.ordersTitle,
            compName: val.compName,
            saleMan: val.saleMan,
            clientManager: val.clientManager,
            saleManager: val.saleManager,
            ordersState: val.ordersState,
            relOrdersNum: val.relOrdersNum,
            relOrdersId: val.relOrdersId
          }
        ];
      }
    }
  },
  data() {
    return {
      tableData: [
        {
          ordersNum: null,
          busType: null,
          ordersTitle: null,
          compName: null,
          saleMan: null,
          clientManager: null,
          saleManager: null,
          ordersState: null,
          relOrdersNum: null,
          relOrdersId: null,
        }
      ]
    };
  },
  methods: {
    openOrderDetail(id) {
      let obj = {
        name: `订单详情2.0-${id}`,
        path: `/order2/orderdetail/${id}`
      };
      window.open(obj.path);
      // this.$store.dispatch("tagsView/addVisitedView", obj);
      // this.$router.push(obj.path);
      return false;
    },
  }
};
</script>

<style>
</style>